/* @flow */
import React, { Component } from 'react';
import referrerFromURL from './../../../utils/referrer-from-url.js';
import percentageChange from './../../../utils/percentage-change.js';
import './visitors/up.png';
import './visitors/down.png';
import './visitors.css';

class Visitors extends Component {

  constructor(props) {
    super(props);
    const cFrames = this.props.cFrames;
    const pFrames = this.props.pFrames;
    let visitorItems = [];
    cFrames.forEach((frame) => {
      frame.visits.forEach((visit) => {
        const referrer = referrerFromURL(visit.referrer);
        let vitem = visitorItems.find((vi) => { return vi.name === referrer; });
        if (!vitem) 
          visitorItems.push({ name: referrer, count: 1, prevCount: 0 });
        else
          vitem.count ++;
      });
    });
    pFrames.forEach((frame) => {
      frame.visits.forEach((visit) => {
        const referrer = referrerFromURL(visit.referrer);
        let vitem = visitorItems.find((vi) => { return vi.name === referrer; });
        if (vitem) vitem.prevCount ++;
      });
    });
    visitorItems.sort((a, b) => {
      if (a.count < b.count)
        return 1;
      else if (a.count > b.count)
        return -1;
      else
        return 0;
    });
    visitorItems = visitorItems.slice(0, 10);
    this.state = { visitorItems: visitorItems };
  }

  render() {
    const listItems = this.state.visitorItems.map((vitem) => {
      let pctChange = percentageChange(vitem.count, vitem.prevCount, 1);
      const pctClassName = (pctChange < 0) ? 'pct-change decr' : 'pct-change incr';
      if (pctChange < 0) pctChange *= -1;
      return (
        <li key={vitem.name}>
          <span className="count">{vitem.count}</span>
          <span className="name">{vitem.name}</span>
          <span className={pctClassName}>{pctChange}%</span>
        </li>
      );
    });
    return (
      <section className="Visitors">
        <header>
          <h2>Where are your shop visitors coming from?</h2>
        </header>
        <div>
          <ul>{listItems}</ul>
        </div>
      </section>
    );
  }

}

export default Visitors;



// WEBPACK FOOTER //
// ./src/app/stats/container/visitors.js